import axios from 'axios';

import { SURVEYSPARROW_TOKEN } from '@/constants/constant';

import { toastError } from '@/components/Toast';

// Create axios instance with common configuration
const surveySparrowAxios = axios.create({
	baseURL: 'https://eu-api.surveysparrow.com/v3',
	headers: {
		Authorization: `Bearer ${SURVEYSPARROW_TOKEN}`,
		'Content-Type': 'application/json'
	}
});

// Generic function to make API calls
const makeApiCall = async (url, method = 'GET', params = {}, requestBody = {}) => {
	try {
		const config = {
			url,
			method,
			params: method === 'GET' ? params : undefined,
			data: method === 'POST' || method === 'PUT' ? requestBody : undefined
		};

		const response = await surveySparrowAxios(config);
		return response.data;
	} catch {
		toastError('Something went wrong');
	}
};

export const surveySparrowApi = {
	get: (url, params = {}) => makeApiCall(url, 'GET', params),
	post: (url, requestBody = {}) => makeApiCall(url, 'POST', {}, requestBody),
	put: (url, requestBody = {}) => makeApiCall(url, 'PUT', {}, requestBody)
};

export default surveySparrowApi;
